<template>
  <div class="staffing-wrapper">
    <!-- Alert no admin -->
    <!-- <transition name="slide-down">
              <div v-if="!isAdmin" class="admin-alert">
                <v-icon small class="mr-2" color="#b45309">mdi-shield-alert-outline</v-icon>
                Solo los administradores pueden crear requerimientos de personal.
              </div>
            </transition> -->

    <!-- Modal Circuito de Aprobacion -->
    <v-dialog
      v-model="dialogCircuit"
      v-if="dialogCircuit"
      width="60%"
      persistent="persistent"
    >
      <hmn-approval-circuit
        :reqID="selectedReqID"
        :reqPstID="selectedReqPstID"
        :reqStatus="selectedReqStatus"
        :bulkRequirements="bulkCircuitRequirements"
        @close="dialogCircuit = false"
        @saved="onCircuitSaved"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogPdfPreview"
      v-if="dialogPdfPreview"
      width="95%"
      persistent="persistent"
    >
      <pdf-hmn-staffing-requirement
        :req-id="selectedPdfReqID"
        @printed="onRequirementPrinted"
        @close="dialogPdfPreview = false"
      />
    </v-dialog>

    <!-- Modal Ajustar Proyección Semanal (Componente Modular) -->
    <weekly-projection-manager
      v-if="dialogAdjustProjections"
      :visible.sync="dialogAdjustProjections"
      :req-id="selectedReqID"
      :reqID="selectedReqID"
      :req-quantity="selectedReqQuantity"
      :periods-list="periodsList"
      :period-year="periodYear"
      @saved="onProjectionSaved"
      @close="dialogAdjustProjections = false"
    />

    <!-- Modal Trazabilidad y Árbol de Ampliaciones -->
    <hmn-staffing-requirement-traceability-modal
      :visible.sync="dialogTraceability"
      :req-id="selectedTraceabilityReqID"
      @close="dialogTraceability = false"
    />

    <!-- Diálogo de Advertencia / Detección de Requerimiento Existente -->
    <v-dialog v-model="dialogExistingPrompt" max-width="530" persistent>
      <v-card class="elevation-12 rounded-lg">
        <v-card-title
          class="headline primary white--text py-3 px-4 d-flex align-center"
        >
          <v-icon color="white" class="mr-2">mdi-alert-circle-outline</v-icon>
          Requerimiento Existente Detectado
        </v-card-title>
        <v-card-text class="pt-4 pb-2">
          <p class="body-1 text--primary mb-3">
            Ya existe un requerimiento activo para la campaña y cargo
            seleccionados:
          </p>
          <div
            v-if="existingActiveRequirement"
            class="pa-3 rounded mb-3"
            style="background: #f1f5f9; border-left: 4px solid #3b82f6"
          >
            <div class="mb-1">
              <strong>ID Requerimiento:</strong> #{{
                existingActiveRequirement.ReqID
              }}
            </div>
            <div class="mb-1">
              <strong>Vacantes Actuales:</strong>
              {{ existingActiveRequirement.ReqQuantity }}
            </div>
            <div>
              <strong>Estado:</strong>
              {{ existingActiveRequirement.ReqStatusName }}
            </div>
          </div>
          <p class="body-2 grey--text text--darken-2 mb-0">
            ¿Desea crear este requerimiento como una
            <strong>Ampliación</strong> del anterior para sumar vacantes y
            unificar la trazabilidad?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="cancelExtensionPrompt">
            Continuar independiente
          </v-btn>
          <v-btn color="primary" class="px-4" @click="confirmExtensionPrompt">
            <v-icon small class="mr-1">mdi-source-branch</v-icon>
            Sí, crear ampliación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Aprobación / Rechazo Masivo -->
    <v-dialog v-model="dialogBulkApproval" max-width="600" persistent>
      <v-card class="rounded-xl elevation-12 overflow-hidden">
        <v-card-title
          :class="
            bulkActionType === 'approve'
              ? 'success white--text'
              : 'error white--text'
          "
          class="py-3 px-4 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-2">
              {{
                bulkActionType === "approve"
                  ? "mdi-checkbox-multiple-marked-circle-outline"
                  : "mdi-close-octagon-outline"
              }}
            </v-icon>
            <span class="font-weight-bold text-subtitle-1">
              {{
                bulkActionType === "approve"
                  ? "Aprobación Masiva"
                  : "Rechazo Masivo"
              }}
              de Requerimientos
            </span>
          </div>
          <v-chip
            small
            color="white"
            :class="
              bulkActionType === 'approve' ? 'success--text' : 'error--text'
            "
            class="font-weight-bold"
          >
            {{ selectedRequirements.length }} seleccionado(s)
          </v-chip>
        </v-card-title>

        <v-card-text class="pt-4 pb-2">
          <p class="body-2 text--primary mb-2">
            {{
              bulkActionType === "approve"
                ? "Se procederá a dar conformidad y firma a los siguientes requerimientos en su turno correspondiente:"
                : "Se rechazarán los siguientes requerimientos y quedarán en estado anulado:"
            }}
          </p>

          <v-sheet
            max-height="160"
            class="overflow-y-auto mb-3 pa-2 rounded-lg"
            color="grey lighten-4"
            outlined
          >
            <div
              v-for="req in selectedRequirements"
              :key="req.ReqID"
              class="d-flex align-center justify-space-between py-1 px-2 mb-1 rounded"
              style="
                background: #ffffff;
                border: 1px solid #e2e8f0;
                font-size: 12px;
              "
            >
              <div>
                <strong>#{{ req.ReqID }}</strong> — {{ req.PstName }}
                <span class="grey--text text--darken-1"
                  >({{ req.CmpName }})</span
                >
              </div>
              <v-chip
                x-small
                color="primary"
                outlined
                class="font-weight-medium"
              >
                {{ req.ReqQuantity }} vacantes
              </v-chip>
            </div>
          </v-sheet>

          <v-textarea
            v-model="bulkObservation"
            :label="
              bulkActionType === 'reject'
                ? 'Motivo del Rechazo (Obligatorio)'
                : 'Observación (Opcional)'
            "
            outlined
            dense
            rows="3"
            :rules="
              bulkActionType === 'reject'
                ? [
                    (v) =>
                      (!!v && v.trim().length > 0) ||
                      'El motivo es obligatorio',
                  ]
                : []
            "
            placeholder="Ingrese un comentario u observación para todos los requerimientos seleccionados..."
            hide-details="auto"
            class="mt-1"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-4 py-3 bg-light">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
            :disabled="processingBulk"
            @click="dialogBulkApproval = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :color="bulkActionType === 'approve' ? 'success' : 'error'"
            class="px-4 white--text font-weight-bold"
            :loading="processingBulk"
            @click="executeBulkApproval"
          >
            <v-icon left small>
              {{
                bulkActionType === "approve"
                  ? "mdi-check-bold"
                  : "mdi-close-thick"
              }}
            </v-icon>
            {{
              bulkActionType === "approve"
                ? "Confirmar Aprobación"
                : "Confirmar Rechazo"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="staffing-container pt-0 pb-0">
      <v-row>
        <v-col lg="12" class="pb-1">
          <s-crud
            ref="grid"
            :searchInput="true"
            :filter="filter"
            no-border="no-border"
            title="Requerimientos de Personal"
            :config="config"
            @save="save($event)"
            :add="true"
            :edit="true"
            :remove="false"
            height="calc(80vh - 200px)"
          >
            <!-- FILTROS -->
            <template v-slot:filter>
              <div class="filter-bar">
                <div class="filter-group">
                  <s-select-campaign-se
                    label="Campaña"
                    v-model="filter.CmpID"
                    clearable
                    class="filter-input"
                  />
                </div>
                <div class="filter-group">
                  <s-select-definition
                    label="Tipo de Requerimiento"
                    :def="1032"
                    v-model="filter.TypeRequirement"
                    clearable
                    class="filter-input"
                  />
                </div>
                <div class="filter-group">
                  <s-select-definition
                    label="Tipo de Búsqueda"
                    :def="1686"
                    v-model="filter.TypeSeeking"
                    clearable
                    class="filter-input"
                  />
                </div>
                <div class="filter-group">
                  <s-select-definition
                    label="Estado"
                    :def="1033"
                    v-model="filter.ReqStatus"
                    clearable
                    class="filter-input"
                  />
                </div>
                <div class="filter-group" v-if="isAdmin">
                  <s-select-area
                    label="Área"
                    v-model="filter.AreID"
                    clearable
                    class="filter-input"
                  />
                </div>
                <!-- Filtro rápido de pendientes de firma -->
                <div
                  class="filter-group d-flex align-center"
                  v-if="!isValidateBudget"
                >
                  <v-switch
                    v-model="filter.OnlyPendingMyApproval"
                    label="Mis pendientes de firma"
                    dense
                    hide-details
                    color="primary"
                    class="mt-0 pt-0 ml-2"
                  />
                </div>
                <!-- Botón rápido seleccionar todos los elegibles -->
                <div
                  class="filter-group d-flex align-center"
                  v-if="!isValidateBudget && hasSelectableRows"
                >
                  <v-btn
                    x-small
                    outlined
                    color="primary"
                    class="select-all-btn"
                    @click="toggleSelectAllEligible"
                  >
                    <v-icon x-small left>{{
                      isAllEligibleSelected
                        ? "mdi-checkbox-blank-outline"
                        : "mdi-checkbox-multiple-marked-outline"
                    }}</v-icon>
                    {{
                      isAllEligibleSelected
                        ? "Deseleccionar todos"
                        : "Seleccionar elegibles"
                    }}
                  </v-btn>
                </div>
              </div>
            </template>

            <!-- FORMULARIO EDICIÓN / CREACIÓN -->
            <template v-slot="props">
              <div class="form-panel">
                <!-- Banner de Ampliación -->
                <div v-if="props.item.ParentReqID" class="extension-banner">
                  <div class="extension-banner-icon">
                    <v-icon color="#0284c7">mdi-source-branch</v-icon>
                  </div>
                  <div class="extension-banner-body">
                    <div class="extension-banner-title">
                      Ampliación del Requerimiento #{{ props.item.ParentReqID }}
                    </div>
                    <div class="extension-banner-text">
                      Este registro sumará vacantes sobre la base anterior
                      (Base:
                      {{ props.item.ParentReqQuantity || "N/A" }} vacantes). La
                      nueva cantidad debe ser superior a
                      {{ props.item.ParentReqQuantity || 0 }}.
                    </div>
                  </div>
                  <v-chip
                    small
                    color="info"
                    outlined
                    class="ml-auto font-weight-bold"
                  >
                    Ampliación
                  </v-chip>
                </div>

                <div class="form-section">
                  <span class="form-section-label">Información general</span>
                  <div class="form-grid">
                    <div class="form-field">
                      <s-select-campaign-se
                        ref="selectCampaign"
                        label="Campaña"
                        v-model="props.item.CmpID"
                        :disabled="
                          isRequirementApproved(props.item) ||
                          !!props.item.ParentReqID
                        "
                        @input="onCampaignSelected($event, props.item)"
                        @datesLoaded="onDatesLoaded($event, props.item)"
                      />
                    </div>
                    <div class="form-field">
                      <s-select-definition
                        ref="typeSeeking"
                        searchable="searchable"
                        label="Tipo de Cobertura"
                        :def="1686"
                        v-model="props.item.TypeSeeking"
                        :disabled="isRequirementApproved(props.item)"
                        :add-custom="$fun.isAdmin()"
                        :custom-fields="[
                          {
                            key: 'DedDescription',
                            label: 'Nombre del Tipo de Cobertura',
                            required: true,
                            cols: 12,
                          },
                        ]"
                      />
                    </div>
                    <div class="form-field" v-show="isAdmin">
                      <s-select-area
                        ref="selectArea"
                        label="Área"
                        v-model="userAreID"
                        :disabled="
                          isRequirementApproved(props.item) ||
                          !!props.item.ParentReqID
                        "
                        :text="props.item.AreName"
                        @change="onAreaChanged($event, props.item)"
                      />
                    </div>
                    <div class="form-field">
                      <s-select-position
                        ref="selectPosition"
                        :disabled="
                          !(props.item.AreID || userAreID) ||
                          isRequirementApproved(props.item) ||
                          !!props.item.ParentReqID
                        "
                        label="Cargo"
                        v-model="props.item.ReqPstID"
                        :text="props.item.PstName"
                        :AreID="props.item.AreID || userAreID"
                        @change="onPositionChanged($event, props.item)"
                      />
                    </div>
                    <div class="form-field">
                      <s-select-definition
                        ref="typeRequirement"
                        label="Tipo"
                        :def="1032"
                        v-model="props.item.TypeRequirement"
                        :disabled="isRequirementApproved(props.item)"
                        :add-custom="$fun.isAdmin()"
                        :custom-fields="[
                          {
                            key: 'DedDescription',
                            label: 'Nombre del Tipo de Requerimiento',
                            required: true,
                            cols: 12,
                          },
                        ]"
                      />
                    </div>
                    <div class="form-field">
                      <s-select-definition
                        :def="1514"
                        v-model="props.item.TypeMotiveRequirement"
                        label="Motivo del requerimiento"
                        :disabled="isRequirementApproved(props.item)"
                        @getDataInitial="motiveRequirementItems = $event"
                        @change="onMotiveRequirementChanged($event, props.item)"
                        :add-custom="$fun.isAdmin()"
                        :custom-fields="[
                          {
                            key: 'DedDescription',
                            label: 'Nombre del Motivo de Requerimiento',
                            required: true,
                            cols: 12,
                          },
                        ]"
                      />
                    </div>
                    <div class="form-field">
                      <s-select-area
                        ref="costCenterArea"
                        v-model="props.item.CceID"
                        :text="props.item.CceName"
                        centercost="centercost"
                        :clearable="true"
                        :disabled="isRequirementApproved(props.item)"
                        label="Centro de Costo"
                      />
                    </div>
                    <!-- <div class="form-field">
                                                                  <s-select-business-line
                                                                    :cceID="props.item.CceID || 0"
                                                                    v-model="props.item.BslID"
                                                                    :text="props.item.BslName"
                                                                    label="Línea de Negocio"
                                                                  />
                                                                </div> -->
                  </div>
                </div>

                <div class="form-section">
                  <span class="form-section-label"
                    >Detalles del requerimiento</span
                  >
                  <div class="form-grid">
                    <div class="form-field">
                      <s-text
                        ref="reqQuantity"
                        label="Cantidad"
                        type="number"
                        v-model="props.item.ReqQuantity"
                        :disabled="isRequirementApproved(props.item)"
                      />
                    </div>
                    <!-- <div class="form-field">
                      <s-select-definition
                        label="Estado"
                        :def="1033"
                        v-model="props.item.ReqStatus"
                        disabled="disabled"
                      />
                    </div> -->
                    <div class="form-field">
                      <s-date
                        label="Fecha Fin Contrato"
                        v-model="props.item.ReqEndContract"
                        :min="minAllowedDate"
                        :disabled="
                          isReqEndContractDisabled(props.item) ||
                          isRequirementApproved(props.item)
                        "
                      />
                    </div>
                    <div class="form-field" v-if="canViewBudget">
                      <s-select-definition
                        :disabled="!canEditBudget"
                        label="Tipo de planilla"
                        :def="1060"
                        v-model="props.item.TypePayroll"
                        :add-custom="$fun.isAdmin()"
                        :custom-fields="[
                          {
                            key: 'DedDescription',
                            label: 'Nombre de Planilla',
                            required: true,
                            cols: 12,
                          },
                        ]"
                      />
                    </div>
                    <div class="form-field" v-if="canViewBudget">
                      <s-select-definition
                        :disabled="!canEditBudget"
                        label="Régimen Laboral"
                        :def="1481"
                        v-model="props.item.TypeLaborRegime"
                        :add-custom="$fun.isAdmin()"
                        :custom-fields="[
                          {
                            key: 'DedDescription',
                            label: 'Nombre del Régimen',
                            required: true,
                            cols: 12,
                          },
                        ]"
                      />
                    </div>
                    <div class="form-field form-field--full">
                      <s-textarea
                        label="Comentarios / Observaciones"
                        v-model="props.item.ReqObservation"
                        :disabled="isRequirementApproved(props.item)"
                        :rows="2"
                        auto-grow
                        placeholder="Ej. 2 ingresan por recomendación, 1 por cobertura especial..."
                      />
                    </div>
                    <!-- Línea de negocio (editable por el validador de presupuesto) -->
                    <!-- <div class="form-field" v-if="canViewBudget">
                                                                  <s-select-business-line
                                                                    ref="selectBsl"
                                                                    :disabled="!canEditBudget"
                                                                    :cceID="props.item.CceID || 0"
                                                                    v-model="props.item.BslID"
                                                                    :text="props.item.BslName || ''"
                                                                    label="Línea de Negocio"
                                                                    clearable
                                                                  />
                                                                </div> -->
                  </div>
                </div>

                <!-- SECCIÓN TIPO DE PAGO (solo visible para validador de presupuesto) -->
                <transition name="fade-expand">
                  <div v-if="canViewBudget" class="form-section">
                    <span class="form-section-label">Información salarial</span>
                    <div class="payment-type-hint">
                      Completa durante la aprobación según el tipo de
                      compensación
                    </div>
                    <div class="form-grid mt-3">
                      <!-- Selector del tipo de pago -->
                      <div class="form-field">
                        <s-select
                          :disabled="!canEditBudget"
                          v-model="props.item.ReqPaymentType"
                          :items="paymentTypeOptions"
                          item-text="label"
                          item-value="value"
                          label="Tipo de Compensación"
                          outlined="outlined"
                          dense="dense"
                          hide-details="hide-details"
                          clearable="clearable"
                        />
                      </div>

                      <!-- Valor 1: Monto fijo / Mínimo / Nivel A -->
                      <div class="form-field" v-if="props.item.ReqPaymentType">
                        <s-text
                          ref="reqPayValue1"
                          :disabled="!canEditBudget"
                          :label="payValue1Label(props.item)"
                          decimal="decimal"
                          :value="getPayDisplayValue(props.item.ReqPayValue1)"
                          @input="
                            props.item.ReqPayValue1 = $event
                              ? String($event)
                              : null
                          "
                          prefix="S/"
                        />
                      </div>

                      <!-- Valor 2: Máximo / Nivel B (tipos 2 y 3) -->
                      <div
                        class="form-field"
                        v-if="
                          [2, 3].includes(Number(props.item.ReqPaymentType))
                        "
                      >
                        <s-text
                          ref="reqPayValue2"
                          :disabled="!canEditBudget"
                          :label="payValue2Label(props.item)"
                          decimal="decimal"
                          :value="getPayDisplayValue(props.item.ReqPayValue2)"
                          @input="
                            props.item.ReqPayValue2 = $event
                              ? String($event)
                              : null
                          "
                          prefix="S/"
                        />
                      </div>

                      <!-- Valor 3: Tipo C (solo tipo 3) -->
                      <div
                        class="form-field"
                        v-if="Number(props.item.ReqPaymentType) === 3"
                      >
                        <s-text
                          ref="reqPayValue3"
                          :disabled="!canEditBudget"
                          label="Tipo C"
                          decimal="decimal"
                          :value="getPayDisplayValue(props.item.ReqPayValue3)"
                          @input="
                            props.item.ReqPayValue3 = $event
                              ? String($event)
                              : null
                          "
                          prefix="S/"
                        />
                      </div>
                    </div>
                  </div>
                </transition>

                <!-- PROYECCIÓN SEMANAL (MASIVO / CAMPAÑA) -->
                <transition name="fade-expand">
                  <div
                    v-if="isCampaignType(props.item)"
                    class="form-section projection-section"
                  >
                    <div class="projection-header">
                      <div>
                        <span class="form-section-label"
                          >Proyección semanal</span
                        >
                        <span class="projection-hint">
                          Define la distribución de personal por semana. (Máx.
                          {{ props.item.ReqQuantity }}
                          por semana)
                        </span>
                      </div>
                      <button
                        class="btn-add-projection"
                        @click="addProjection(props.item)"
                      >
                        <v-icon small="small" class="mr-1">mdi-plus</v-icon>
                        Agregar semana
                      </button>
                    </div>

                    <div
                      v-if="
                        !props.item.Projections ||
                        props.item.Projections.filter((p) => p.SecStatus !== 0)
                          .length === 0
                      "
                      class="projection-empty"
                    >
                      <v-icon color="#94a3b8" class="mb-1"
                        >mdi-calendar-blank-outline</v-icon
                      >
                      <span>Agrega al menos una semana de proyección.</span>
                    </div>

                    <v-row v-else="v-else">
                      <!-- Columna Izquierda: Listado de Proyecciones -->
                      <v-col cols="12" lg="8">
                        <div class="projection-list">
                          <div class="projection-list-header">
                            <span>Semana</span>
                            <span>Turno</span>
                            <span>Total Proyectado</span>
                            <span>Hombres</span>
                            <span>Mujeres</span>
                            <span></span>
                          </div>
                          <transition-group name="row-fade" tag="div">
                            <div
                              class="projection-row"
                              v-for="(
                                row, index
                              ) in props.item.Projections.filter(
                                (p) => p.SecStatus !== 0,
                              )"
                              :key="row.WprID || index"
                            >
                              <div class="projection-cell">
                                <s-periods
                                  label=""
                                  v-model="row.PdsID"
                                  :year="periodYear"
                                  :type="1"
                                  clearable="clearable"
                                  :disabled="
                                    isRequirementApproved(props.item) ||
                                    (!isAdmin &&
                                      row.WprID > 0 &&
                                      isPastPeriod(row.PdsID))
                                  "
                                  @input="
                                    updateProjectionGender(
                                      row,
                                      'week',
                                      props.item,
                                    )
                                  "
                                />
                              </div>
                              <div class="projection-cell">
                                <s-select-definition
                                  :showLabel="false"
                                  :def="1278"
                                  v-model="row.TypeTurn"
                                  dense="dense"
                                  outlined="outlined"
                                  :disabled="
                                    isRequirementApproved(props.item) ||
                                    (!isAdmin &&
                                      row.WprID > 0 &&
                                      isPastPeriod(row.PdsID))
                                  "
                                />
                              </div>
                              <div class="projection-cell">
                                <v-text-field
                                  ref="WprQuantityProject"
                                  v-model="row.WprQuantityProject"
                                  type="number"
                                  min="1"
                                  :max="props.item.ReqQuantity"
                                  dense="dense"
                                  outlined="outlined"
                                  hide-details="hide-details"
                                  class="qty-field"
                                  :disabled="
                                    isRequirementApproved(props.item) ||
                                    (!isAdmin &&
                                      row.WprID > 0 &&
                                      isPastPeriod(row.PdsID))
                                  "
                                  @input="
                                    updateProjectionGender(
                                      row,
                                      'total',
                                      props.item,
                                    )
                                  "
                                />
                              </div>
                              <div class="projection-cell">
                                <v-text-field
                                  v-model="row.WprQuantityMale"
                                  type="number"
                                  min="0"
                                  :max="row.WprQuantityProject"
                                  dense="dense"
                                  outlined="outlined"
                                  hide-details="hide-details"
                                  class="qty-field"
                                  :disabled="
                                    isRequirementApproved(props.item) ||
                                    (!isAdmin &&
                                      row.WprID > 0 &&
                                      isPastPeriod(row.PdsID))
                                  "
                                  @input="
                                    updateProjectionGender(
                                      row,
                                      'male',
                                      props.item,
                                    )
                                  "
                                />
                              </div>
                              <div class="projection-cell">
                                <v-text-field
                                  v-model="row.WprQuantityFemale"
                                  type="number"
                                  min="0"
                                  :max="row.WprQuantityProject"
                                  dense="dense"
                                  outlined="outlined"
                                  hide-details="hide-details"
                                  class="qty-field"
                                  :disabled="
                                    isRequirementApproved(props.item) ||
                                    (!isAdmin &&
                                      row.WprID > 0 &&
                                      isPastPeriod(row.PdsID))
                                  "
                                  @input="
                                    updateProjectionGender(
                                      row,
                                      'female',
                                      props.item,
                                    )
                                  "
                                />
                              </div>
                              <div
                                class="projection-cell projection-cell--action"
                              >
                                <button
                                  v-if="
                                    !isRequirementApproved(props.item) &&
                                    (isAdmin ||
                                      !(
                                        row.WprID > 0 && isPastPeriod(row.PdsID)
                                      ))
                                  "
                                  class="btn-remove-projection"
                                  @click="removeProjection(props.item, row)"
                                  title="Eliminar"
                                >
                                  <v-icon small="small">mdi-close</v-icon>
                                </button>
                              </div>
                            </div>
                          </transition-group>
                        </div>
                      </v-col>

                      <!-- Columna Derecha: Componente Consolidador -->
                      <v-col cols="12" lg="4">
                        <s-weekly-staffing-helper
                          :projections="props.item.Projections"
                          :req-quantity="Number(props.item.ReqQuantity) || 0"
                          :periods-list="periodsList"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </transition>

                <!-- CRONOGRAMA DE INGRESO ESTIMADO (RECLUTAMIENTO PROFESIONAL) -->
                <transition name="fade-expand">
                  <div
                    v-if="!isCampaignType(props.item)"
                    class="form-section projection-section"
                  >
                    <div class="projection-header">
                      <div>
                        <span class="form-section-label"
                          >Cronograma de ingreso estimado</span
                        >
                        <span class="projection-hint">
                          Define las fechas estimadas de ingreso y la cantidad
                          requerida para cada fecha. (Total vacantes:
                          {{ props.item.ReqQuantity }})
                        </span>
                      </div>
                      <button
                        v-if="!isRequirementApproved(props.item)"
                        class="btn-add-projection"
                        @click="addProfessionalProjection(props.item)"
                      >
                        <v-icon small="small" class="mr-1">mdi-plus</v-icon>
                        Agregar fecha estimada
                      </button>
                    </div>

                    <div
                      v-if="
                        !props.item.ProfessionalSchedules ||
                        props.item.ProfessionalSchedules.filter(
                          (p) => p.SecStatus !== 0,
                        ).length === 0
                      "
                      class="projection-empty"
                    >
                      <v-icon color="#94a3b8" class="mb-1"
                        >mdi-calendar-blank-outline</v-icon
                      >
                      <span
                        >Agrega las fechas estimadas de ingreso de
                        personal.</span
                      >
                    </div>

                    <div v-else>
                      <div class="projection-list mb-3">
                        <div class="prof-projection-list-header">
                          <span>Fecha Estimada</span>
                          <span>Cantidad Estimada</span>
                          <span></span>
                        </div>
                        <transition-group name="row-fade" tag="div">
                          <div
                            class="prof-projection-row"
                            v-for="(
                              row, index
                            ) in props.item.ProfessionalSchedules.filter(
                              (p) => p.SecStatus !== 0,
                            )"
                            :key="row.PscID || index"
                          >
                            <div class="projection-cell">
                              <s-date
                                label=""
                                v-model="row.PscEstimatedDate"
                                :min="minAllowedDate"
                                :disabled="isRequirementApproved(props.item)"
                              />
                            </div>
                            <div class="projection-cell">
                              <v-text-field
                                v-model.number="row.PscQuantityProject"
                                type="number"
                                min="1"
                                :max="props.item.ReqQuantity"
                                dense="dense"
                                outlined="outlined"
                                hide-details="hide-details"
                                class="qty-field"
                                :disabled="isRequirementApproved(props.item)"
                                @input="
                                  validateProfessionalRowQty(row, props.item)
                                "
                              />
                            </div>
                            <div
                              class="projection-cell projection-cell--action"
                            >
                              <button
                                v-if="!isRequirementApproved(props.item)"
                                class="btn-remove-projection"
                                @click="
                                  removeProfessionalSchedule(props.item, row)
                                "
                                title="Eliminar"
                              >
                                <v-icon small="small">mdi-close</v-icon>
                              </button>
                            </div>
                          </div>
                        </transition-group>
                      </div>

                      <!-- Resumen Total Cronograma Profesional -->
                      <div class="projection-summary-card">
                        <div class="summary-card-title">
                          <v-icon small class="mr-1" color="#475569"
                            >mdi-chart-pie</v-icon
                          >
                          Resumen Cronograma de Ingreso Estimado
                        </div>
                        <div
                          class="d-flex align-center justify-space-between px-2"
                        >
                          <div>
                            <span
                              class="font-weight-medium text-caption grey--text text--darken-2"
                            >
                              Total Estimado Distribuido:
                            </span>
                            <span
                              :class="getDistributionClass(props.item)"
                              class="ml-2 font-weight-bold"
                            >
                              {{ getDistributedTotal(props.item) }} /
                              {{ props.item.ReqQuantity }} vacantes
                            </span>
                          </div>
                          <v-chip
                            x-small
                            :color="
                              getDistributedTotal(props.item) ===
                              Number(props.item.ReqQuantity)
                                ? 'success'
                                : getDistributedTotal(props.item) >
                                  Number(props.item.ReqQuantity)
                                ? 'error'
                                : 'warning'
                            "
                            outlined
                          >
                            {{
                              getDistributedTotal(props.item) ===
                              Number(props.item.ReqQuantity)
                                ? "Completo"
                                : getDistributedTotal(props.item) >
                                  Number(props.item.ReqQuantity)
                                ? "Excede vacantes"
                                : "Incompleto"
                            }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </template>

            <!-- COLUMNA SELECCIÓN MASIVA -->
            <template v-slot:SelectAction="{ row }">
              <div class="d-flex justify-center align-center">
                <v-tooltip bottom v-if="!isRowSelectable(row)">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-inline-block">
                      <v-simple-checkbox
                        :value="false"
                        disabled
                        color="grey"
                        style="opacity: 0.35"
                      />
                    </div>
                  </template>
                  <span>{{ getSelectableTooltip(row) }}</span>
                </v-tooltip>
                <v-simple-checkbox
                  v-else
                  :value="isRowSelected(row)"
                  @input="toggleRowSelection(row)"
                  color="primary"
                  class="cursor-pointer"
                />
              </div>
            </template>

            <!-- ACCIONES DE FILA -->
            <template v-slot:AsgAction="{ row }">
              <div class="row-actions">
                <button
                  v-if="row.ReqStatus >= 1"
                  class="action-btn action-btn--print"
                  title="Previsualizar requerimiento"
                  @click="openPdfPreview(row)"
                >
                  <v-icon x-small="x-small">mdi-eye-outline</v-icon>
                </button>
                <button
                  v-if="
                    row.ReqStatus === 1 && row.UsrCreateID == $fun.getUserID()
                  "
                  class="action-btn action-btn--send"
                  @click="openCircuitConfig(row)"
                >
                  Enviar
                </button>
                <button
                  v-if="row.ReqStatus >= 2 && row.ReqStatus !== 7"
                  class="action-btn action-btn--view"
                  @click="openCircuitView(row)"
                >
                  Ver circuito
                </button>
                <button
                  v-if="
                    isFullyApproved(row) &&
                    row.TypeRequirement == 2 &&
                    row.UsrCreateID == $fun.getUserID()
                  "
                  class="action-btn action-btn--adjust"
                  title="Ajustar proyección semanal"
                  @click="openAdjustProjections(row)"
                >
                  <v-icon x-small="x-small" class="mr-1"
                    >mdi-calendar-edit</v-icon
                  >
                  Ajustar
                </button>
                <button
                  v-if="
                    isFullyApproved(row) && row.UsrCreateID == $fun.getUserID()
                  "
                  class="action-btn action-btn--expand"
                  title="Crear ampliación de este requerimiento"
                  @click="openCreateExtension(row)"
                >
                  <v-icon x-small="x-small" class="mr-1"
                    >mdi-arrow-expand-all</v-icon
                  >
                  Ampliar
                </button>
                <button
                  v-show="$fun.isAdmin()"
                  class="action-btn action-btn--trace"
                  title="Ver árbol de trazabilidad y ampliaciones"
                  @click="openTraceability(row)"
                >
                  <v-icon x-small="x-small" class="mr-1"
                    >mdi-sitemap-outline</v-icon
                  >
                  Trazabilidad
                </button>
                <button
                  v-if="
                    Number(row.ReqStatus) === 1 &&
                    (row.UsrCreateID == $fun.getUserID() || $fun.isAdmin())
                  "
                  class="action-btn action-btn--delete"
                  title="Eliminar requerimiento borrador"
                  @click="deleteRequirement(row)"
                >
                  <v-icon x-small="x-small" color="red darken-2">mdi-trash-can-outline</v-icon>
                </button>
              </div>
            </template>
          </s-crud>

          <!-- BARRA FLOTANTE DE ACCIONES MASIVAS -->
          <transition name="slide-fade">
            <div
              v-if="selectedRequirements.length > 0"
              class="bulk-floating-bar elevation-8"
            >
              <div class="bulk-floating-content">
                <div
                  class="bulk-badge"
                  :style="
                    selectionMode === 'draft'
                      ? 'background: #6366f1;'
                      : 'background: #3b82f6;'
                  "
                >
                  <v-icon small color="white" class="mr-1">
                    {{
                      selectionMode === "draft"
                        ? "mdi-file-send-outline"
                        : "mdi-checkbox-multiple-marked"
                    }}
                  </v-icon>
                  <span>{{ selectedRequirements.length }}</span>
                </div>
                <span class="bulk-label font-weight-medium">
                  {{
                    selectionMode === "draft"
                      ? "Borrador(es) para envío"
                      : "Requerimiento(s) seleccionado(s)"
                  }}
                </span>
                <div class="bulk-actions">
                  <!-- ACCIÓN PARA BORRADORES: ENVIAR A CIRCUITO -->
                  <template v-if="selectionMode === 'draft'">
                    <v-btn
                      small
                      depressed
                      color="indigo"
                      class="bulk-btn white--text font-weight-bold"
                      @click="openBulkCircuitConfig"
                    >
                      <v-icon small left>mdi-sitemap</v-icon>
                      Ver y Configurar Circuito ({{
                        selectedRequirements.length
                      }})
                    </v-btn>
                    <v-btn
                      small
                      outlined
                      color="indigo lighten-4"
                      class="bulk-btn white--text"
                      :loading="processingBulkSend"
                      @click="executeBulkSend"
                      title="Enviar directamente con el circuito por defecto"
                    >
                      <v-icon small left>mdi-send-fast</v-icon>
                      Envío Rápido
                    </v-btn>
                  </template>

                  <!-- ACCIÓN PARA PENDIENTES DE FIRMA: APROBAR / RECHAZAR -->
                  <template
                    v-else-if="
                      selectionMode === 'approval' && !isValidateBudget
                    "
                  >
                    <v-btn
                      small
                      depressed
                      color="success"
                      class="bulk-btn white--text"
                      @click="openBulkApproval('approve')"
                    >
                      <v-icon small left>mdi-check-all</v-icon>
                      Aprobar ({{ selectedRequirements.length }})
                    </v-btn>
                    <v-btn
                      small
                      depressed
                      color="error"
                      class="bulk-btn white--text"
                      @click="openBulkApproval('reject')"
                    >
                      <v-icon small left>mdi-close-octagon</v-icon>
                      Rechazar ({{ selectedRequirements.length }})
                    </v-btn>
                  </template>

                  <v-btn
                    small
                    text
                    color="grey darken-3"
                    class="bulk-btn-clear"
                    @click="clearSelection"
                    title="Desmarcar todos"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SSelectCampaign from "@/components/Utils/SSelectCampaign.vue";
import SSelectCampaignSe from "@/components/Utils/SSelectCampaignSe.vue";
import SSelectArea from "@/components/Utils/SSelectArea.vue";
import SSelectPosition from "@/components/Utils/sSelectPosition.vue";
import SPeriods from "@/components/Utils/SPeriods.vue";
import SSelectBusinessLine from "@/components/Utils/SSelectBusinessLine.vue";
import PdfHmnStaffingRequirement from "./PdfHmnStaffingRequirement.vue";
import HmnApprovalCircuit from "./HmnApprovalCircuit.vue";
import _sGenParam from "@/services/General/ParameterService";
import _sHmnStaffingRequirement from "@/services/HumanResource/RecruitmentSelection/HmnStaffingRequirement.js";
import _sAuditService from "@/services/HumanResource/RecruitmentSelection/AuditService.js";
import _sApproval from "@/services/HumanResource/RecruitmentSelection/HmnRequirementApprovalService.js";
import _sGenPositionProfile from "@/services/General/GenPositionProfileService.js";
import { createModuleAuditLogger } from "@/utils/moduleAudit";
import _sCreationPeriods from "@/services/HumanResource/CreationPeriods";
import SWeeklyStaffingHelper from "@/components/HumanResource/SWeeklyStaffingHelper.vue";
import WeeklyProjectionManager from "@/components/HumanResource/RecruitmentMassive/WeeklyProjectionManager.vue";
import HmnStaffingRequirementTraceabilityModal from "./HmnStaffingRequirementTraceabilityModal.vue";

export default {
  name: "HmnStaffingRequirement",
  components: {
    SSelectCampaign,
    SSelectCampaignSe,
    SSelectArea,
    SSelectPosition,
    SPeriods,
    SSelectBusinessLine,
    PdfHmnStaffingRequirement,
    HmnApprovalCircuit,
    SWeeklyStaffingHelper,
    WeeklyProjectionManager,
    HmnStaffingRequirementTraceabilityModal,
  },
  data() {
    return {
      motiveRequirementItems: [],
      isAdmin: this.$fun.isAdmin(),
      periodYear: new Date().getFullYear(),
      userAreID: 0,
      dialogCircuit: false,
      dialogPdfPreview: false,
      selectedReqID: 0,
      selectedReqPstID: 0,
      selectedReqStatus: 1,
      selectedPdfReqID: 0,
      isValidateBudget: false,
      selectedRequirements: [],
      bulkCircuitRequirements: [],
      dialogBulkApproval: false,
      bulkActionType: "approve",
      bulkObservation: "",
      processingBulk: false,
      processingBulkSend: false,
      filter: {
        isAdmin: false,
        UsrCreateID: null,
        ReqStatus: null,
        TypeRequirement: null,
        TypeSeeking: null,
        CmpID: null,
        AreID: null,
        PstID: 0,
        OnlyPendingMyApproval: false,
      },
      defaultHeaderData: {
        codigo: "SIG-ES-RH-FR-001",
        version: "04",
        fechaCreacion: "",
        ultimaRevision: "",
      },
      config: {
        model: {
          SelectAction: "",
          ReqID: "ID",
          SecCreate: "datetime",
          ReqEndContract: "date",
          AsgAction: "",
        },
        service: _sHmnStaffingRequirement,
        headers: this.isAdmin
          ? [
              {
                text: "",
                value: "SelectAction",
                sortable: false,
                width: 45,
                align: "center",
              },
              {
                text: "ID",
                value: "ReqID",
                width: 90,
              },
              {
                text: "Campaña",
                value: "CmpName",
              },
              {
                text: "Área",
                value: "AreName",
              },
              {
                text: "Cargo",
                value: "PstName",
              },
              {
                text: "Tipo",
                value: "TypeRequirementName",
              },
              {
                text: "Cantidad",
                value: "ReqQuantity",
              },
              {
                text: "Estado",
                value: "ReqStatusName",
              },
              {
                text: "Fecha Creación",
                value: "SecCreate",
              },
              {
                text: "Planilla",
                value: "TypePayrollName",
              },
              {
                text: "Tipo Busqueda",
                value: "TypeSeekingName",
              },
              {
                text: "Acciones",
                value: "AsgAction",
                sortable: false,
                width: 160,
              },
            ]
          : [
              {
                text: "",
                value: "SelectAction",
                sortable: false,
                width: 45,
                align: "center",
              },
              {
                text: "ID",
                value: "ReqID",
              },
              {
                text: "Campaña",
                value: "CmpName",
              },
              {
                text: "Cargo",
                value: "PstName",
              },
              {
                text: "Cantidad",
                value: "ReqQuantity",
              },
              {
                text: "Estado",
                value: "ReqStatusName",
              },
              {
                text: "Tipo",
                value: "TypeRequirementName",
              },
              {
                text: "Fecha Creación",
                value: "SecCreate",
              },
              {
                text: "Planilla",
                value: "TypePayrollName",
              },
              {
                text: "Tipo Busqueda",
                value: "TypeSeekingName",
              },
              {
                text: "Acciones",
                value: "AsgAction",
                sortable: false,
                align: "center",
              },
            ],
      },
      paymentTypeOptions: [
        {
          value: 1,
          label: "Monto Fijo",
        },
        {
          value: 2,
          label: "Rango (mín - máx)",
        },
        {
          value: 3,
          label: "Por Niveles (A / B / C)",
        },
      ],
      auditLogger: null,
      dialogAdjustProjections: false,
      dialogTraceability: false,
      selectedTraceabilityReqID: 0,
      dialogExistingPrompt: false,
      existingActiveRequirement: null,
      currentFormItem: null,
      selectedReqQuantity: 0,
      periodsList: [],
      currentCampaignDates: null,
    };
  },
  mounted() {
    _sGenParam
      .search(
        {
          PrmName: "ValBudgetPstID_RRHH",
        },
        this.$fun.getUserID(),
      )
      .then((response) => {
        const validators = response.data.PrmValue.split(",").map((id) =>
          parseInt(id.trim()),
        );

        this.isValidateBudget =
          validators.indexOf(this.$fun.getUserInfo().CtrContract?.PstID) !== -1;
      });
    this.isAdmin
      ? (this.filter.isAdmin = true)
      : (this.filter.UsrCreateID = this.$fun.getUserID());
    this.filter.PstID = this.$fun.getUserInfo().CtrContract?.PstID || 0;
    this.loadPeriods();
  },
  computed: {
    userPstID() {
      const info = this.$fun.getUserInfo();
      return info && info.CtrContract ? info.CtrContract.PstID : 0;
    },
    minAllowedDate() {
      if (this.isAdmin) return "";
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    canViewBudget() {
      return this.isAdmin || this.isValidateBudget;
    },
    canEditBudget() {
      return this.isValidateBudget;
    },
    selectionMode() {
      if (!this.selectedRequirements.length) return null;
      return Number(this.selectedRequirements[0].ReqStatus) === 1
        ? "draft"
        : "approval";
    },
    eligibleRows() {
      const rows = this.$refs?.grid?.desserts || [];
      return rows.filter((r) => this.isRowSelectable(r));
    },
    hasSelectableRows() {
      return this.eligibleRows.length > 0;
    },
    isAllEligibleSelected() {
      if (this.eligibleRows.length === 0) return false;
      return this.eligibleRows.every((r) => this.isRowSelected(r));
    },
  },
  methods: {
    // ---- Helpers para campos de pago ----
    getPayDisplayValue(value) {
      if (value === null || value === undefined || value === "") return null;

      const numericValue = Number(value);
      if (!Number.isNaN(numericValue) && String(value).trim() !== "") {
        return numericValue;
      }
      try {
        const decrypted = this.$fun.decrypt(value);
        const parsed = Number(decrypted);
        return Number.isNaN(parsed) ? decrypted : parsed;
      } catch {
        return value;
      }
    },
    payValue1Label(item) {
      const t = Number(item.ReqPaymentType);
      if (t === 1) return "Monto Fijo";

      if (t === 2) return "Mínimo";

      if (t === 3) return "Tipo A";

      return "Valor";
    },
    payValue2Label(item) {
      const t = Number(item.ReqPaymentType);
      if (t === 2) return "Máximo";

      if (t === 3) return "Tipo B";

      return "Valor 2";
    },
    encryptPayValues(item) {
      if (!this.canEditBudget) return;

      const encrypt = (v) => {
        if (v === null || v === undefined || v === "") return null;
        const num = this.getPayDisplayValue(v);
        if (
          num !== null &&
          num !== undefined &&
          !Number.isNaN(Number(num)) &&
          Number(num) > 0
        ) {
          return this.$fun.encrypt(String(num));
        }
        return null;
      };
      item.ReqPayValue1 = encrypt(item.ReqPayValue1);
      item.ReqPayValue2 = encrypt(item.ReqPayValue2);
      item.ReqPayValue3 = encrypt(item.ReqPayValue3);
    },
    // ---- Fin helpers ----
    openPdfPreview(row) {
      this.selectedPdfReqID = row?.ReqID || 0;
      if (!this.selectedPdfReqID) {
        this.$fun.alert("No se encontró el ID del requerimiento", "warning");
        return;
      }
      this.auditRequirementAction("VIEW", row, {
        source: "staffing-requirement-grid",
        actionOrigin: "openPdfPreview",
      });
      this.dialogPdfPreview = true;
    },
    onRequirementPrinted(payload) {
      const row = {
        ReqID: payload?.reqId || this.selectedPdfReqID,
      };
      this.auditRequirementAction("PRINT", row, {
        source: "staffing-requirement-pdf",
        actionOrigin: payload?.source || "pdf-print",
      });
    },
    normalizeAuditDate(value) {
      if (!value) return null;

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      return date.toISOString().slice(0, 10);
    },
    toAuditRequirementSnapshot(item) {
      if (!item) return {};

      return {
        CmpID: item.CmpID || null,
        TypeSeeking: item.TypeSeeking || null,
        TypeRequirement: item.TypeRequirement || null,
        TypeMotiveRequirement: item.TypeMotiveRequirement || null,
        AreID: item.AreID || this.userAreID || null,
        ReqPstID: item.ReqPstID || null,
        ReqQuantity: item.ReqQuantity || null,
        ReqEndContract: item.ReqEndContract,
        ReqObservation: item.ReqObservation || null,
        CceID: item.CceID || null,
        TypePayroll: item.TypePayroll || null,
        TypeLaborRegime: item.TypeLaborRegime || null,
        ReqPaymentType: item.ReqPaymentType || null,
        ReqPayValue1: this.getPayDisplayValue(item.ReqPayValue1),
        ReqPayValue2: this.getPayDisplayValue(item.ReqPayValue2),
        ReqPayValue3: this.getPayDisplayValue(item.ReqPayValue3),
      };
    },
    buildRequirementChangeSet(previous, current) {
      const fields = Object.keys(current || {});
      const changes = [];

      fields.forEach((field) => {
        const before = (previous || {})[field];
        const after = (current || {})[field];

        if (String(before ?? "") !== String(after ?? "")) {
          changes.push({ field, before, after });
        }
      });

      return changes;
    },
    auditRequirementAction(actionType, row, metadata = {}, changes = null) {
      if (!this.auditLogger) return;

      const userInfo = this.$fun.getUserInfo() || {};
      const contextMetadata = {
        userPstID: userInfo?.CtrContract?.PstID || 0,
        userAreID: userInfo?.CtrContract?.AreID || 0,
        isValidateBudget: this.isValidateBudget,
        canEditBudget: this.canEditBudget,
        ...metadata,
      };

      this.auditLogger.track({
        actionType,
        documentID: Number(row?.ReqID || 0),
        documentCode: row?.ReqID ? `REQ-${row.ReqID}` : null,
        isAdminAction: this.isAdmin,
        hasElevatedPermission: this.canEditBudget,
        changes,
        metadata: contextMetadata,
      });
    },
    async loadHeaderConfig() {
      const fallback = {
        ...this.defaultHeaderData,
      };
      try {
        const resp = await _sGenParam.listoptions(
          {
            Search: "PdfHmnStaffingRequirement",
          },
          this.$fun.getUserID(),
        );

        if (!(resp.status === 200 && resp.data && resp.data.length)) {
          return fallback;
        }

        const rawValue = resp.data[0]?.PrmValue;
        if (!rawValue) {
          return fallback;
        }

        const parsed = JSON.parse(rawValue);
        return {
          ...fallback,
          codigo: parsed.codigo || fallback.codigo,
          version: parsed.version || fallback.version,
          fechaCreacion: parsed.fechaCreacion || fallback.fechaCreacion,
          ultimaRevision: parsed.ultimaRevision || fallback.ultimaRevision,
        };
      } catch (error) {
        return fallback;
      }
    },
    async onCampaignSelected(cmpID, item) {
      if (!cmpID) {
        this.currentCampaignDates = null;
        if (this.isReqEndContractDisabled(item) || !item.ReqEndContract) {
          item.ReqEndContract = null;
        }
      } else if (item.ReqPstID && !item.ReqID && !item.ParentReqID) {
        await this.checkAndPromptExtension(item);
      }
    },
    async onPositionChanged(pstID, item) {
      if (pstID && item.CmpID && !item.ReqID && !item.ParentReqID) {
        await this.checkAndPromptExtension(item);
      }
    },
    async checkAndPromptExtension(item) {
      if (!item.CmpID || !item.ReqPstID) return;
      try {
        const res = await _sHmnStaffingRequirement.checkActive(
          {
            cmpID: item.CmpID,
            reqPstID: item.ReqPstID,
            currentReqID: item.ReqID || 0,
          },
          this.$fun.getUserID(),
        );
        if (res && res.data && res.data.HasActive) {
          this.existingActiveRequirement = res.data;
          this.currentFormItem = item;
          this.dialogExistingPrompt = true;
        }
      } catch (e) {
        console.error("Error al verificar requerimiento activo:", e);
      }
    },
    async confirmExtensionPrompt() {
      if (this.currentFormItem && this.existingActiveRequirement) {
        const parentId = this.existingActiveRequirement.ReqID;
        const parentQty =
          Number(this.existingActiveRequirement.ReqQuantity) || 0;

        this.$set(this.currentFormItem, "ParentReqID", parentId);
        this.$set(this.currentFormItem, "ParentReqQuantity", parentQty);

        if (Number(this.currentFormItem.ReqQuantity || 0) <= parentQty) {
          this.$set(this.currentFormItem, "ReqQuantity", parentQty + 1);
        }

        try {
          const parentResp = await _sHmnStaffingRequirement.byID(
            parentId,
            this.$fun.getUserID(),
          );
          const parentData = parentResp?.data;
          if (parentData) {
            if (
              !this.currentFormItem.TypeRequirement &&
              parentData.TypeRequirement
            ) {
              this.$set(
                this.currentFormItem,
                "TypeRequirement",
                parentData.TypeRequirement,
              );
            }
            if (!this.currentFormItem.TypeSeeking && parentData.TypeSeeking) {
              this.$set(
                this.currentFormItem,
                "TypeSeeking",
                parentData.TypeSeeking,
              );
            }
            if (!this.currentFormItem.CceID && parentData.CceID) {
              this.$set(this.currentFormItem, "CceID", parentData.CceID);
              this.$set(this.currentFormItem, "CceName", parentData.CceName);
            }
            if (!this.currentFormItem.TypePayroll && parentData.TypePayroll) {
              this.$set(
                this.currentFormItem,
                "TypePayroll",
                parentData.TypePayroll,
              );
            }
            if (parentData.ReqPaymentType) {
              this.$set(
                this.currentFormItem,
                "ReqPaymentType",
                parentData.ReqPaymentType,
              );
              this.$set(
                this.currentFormItem,
                "ReqPayValue1",
                this.getPayDisplayValue(parentData.ReqPayValue1),
              );
              this.$set(
                this.currentFormItem,
                "ReqPayValue2",
                this.getPayDisplayValue(parentData.ReqPayValue2),
              );
              this.$set(
                this.currentFormItem,
                "ReqPayValue3",
                this.getPayDisplayValue(parentData.ReqPayValue3),
              );
            }
            if (
              parentData.Projections &&
              parentData.Projections.length &&
              (!this.currentFormItem.Projections ||
                !this.currentFormItem.Projections.length)
            ) {
              const inheritedProj = parentData.Projections.map((p) => ({
                ...p,
                WprID: 0,
                ReqID: 0,
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID(),
              }));
              this.$set(this.currentFormItem, "Projections", inheritedProj);
            }
            if (
              parentData.ProfessionalSchedules &&
              parentData.ProfessionalSchedules.length &&
              (!this.currentFormItem.ProfessionalSchedules ||
                !this.currentFormItem.ProfessionalSchedules.length)
            ) {
              const inheritedSched = parentData.ProfessionalSchedules.map(
                (p) => ({
                  ...p,
                  PscID: 0,
                  ReqID: 0,
                  SecStatus: 1,
                  UsrCreateID: this.$fun.getUserID(),
                }),
              );
              this.$set(
                this.currentFormItem,
                "ProfessionalSchedules",
                inheritedSched,
              );
            }
          }
        } catch (e) {
          console.error("Error al cargar datos del requerimiento base:", e);
        }

        this.$fun.alert(
          `Ampliación vinculada al Requerimiento #${parentId}. La nueva cantidad debe ser estrictamente mayor a ${parentQty}.`,
          "info",
        );
      }
      this.dialogExistingPrompt = false;
    },
    cancelExtensionPrompt() {
      this.dialogExistingPrompt = false;
    },
    async openCreateExtension(row) {
      try {
        const resp = await _sHmnStaffingRequirement.byID(
          row.ReqID,
          this.$fun.getUserID(),
        );
        const parentData = resp?.data || row;
        const parentQty = Number(parentData.ReqQuantity) || 0;

        this.$refs.grid?.btnAdd?.();

        this.$nextTick(() => {
          if (this.$refs.grid) {
            const item = this.$refs.grid.row || {};
            this.userAreID = parentData.AreID || 0;

            this.$set(item, "ReqID", 0);
            this.$set(item, "ParentReqID", parentData.ReqID);
            this.$set(item, "ParentReqQuantity", parentQty);
            this.$set(item, "CmpID", parentData.CmpID);
            this.$set(item, "TypeSeeking", parentData.TypeSeeking);
            this.$set(item, "AreID", parentData.AreID);
            this.$set(item, "AreName", parentData.AreName);
            this.$set(item, "ReqPstID", parentData.ReqPstID);
            this.$set(item, "PstName", parentData.PstName);
            this.$set(item, "TypeRequirement", parentData.TypeRequirement);
            this.$set(
              item,
              "TypeMotiveRequirement",
              parentData.TypeMotiveRequirement,
            );
            this.$set(item, "CceID", parentData.CceID);
            this.$set(item, "CceName", parentData.CceName);
            this.$set(item, "ReqQuantity", parentQty + 1);
            this.$set(item, "ReqEndContract", parentData.ReqEndContract);
            this.$set(item, "TypePayroll", parentData.TypePayroll);
            this.$set(item, "ReqPaymentType", parentData.ReqPaymentType);
            this.$set(
              item,
              "ReqPayValue1",
              this.getPayDisplayValue(parentData.ReqPayValue1),
            );
            this.$set(
              item,
              "ReqPayValue2",
              this.getPayDisplayValue(parentData.ReqPayValue2),
            );
            this.$set(
              item,
              "ReqPayValue3",
              this.getPayDisplayValue(parentData.ReqPayValue3),
            );
            this.$set(
              item,
              "ReqObservation",
              `Ampliación del Requerimiento #${parentData.ReqID}. `,
            );
            this.$set(item, "ReqStatus", 1);

            if (parentData.Projections && parentData.Projections.length) {
              const inheritedProj = parentData.Projections.map((p) => ({
                ...p,
                WprID: 0,
                ReqID: 0,
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID(),
              }));
              this.$set(item, "Projections", inheritedProj);
            }

            if (
              parentData.ProfessionalSchedules &&
              parentData.ProfessionalSchedules.length
            ) {
              const inheritedSched = parentData.ProfessionalSchedules.map(
                (p) => ({
                  ...p,
                  PscID: 0,
                  ReqID: 0,
                  SecStatus: 1,
                  UsrCreateID: this.$fun.getUserID(),
                }),
              );
              this.$set(item, "ProfessionalSchedules", inheritedSched);
            }

            this.$fun.alert(
              `Creando ampliación para el Requerimiento #${
                parentData.ReqID
              } (${parentQty} vacantes base). Ingrese la nueva cantidad total (mínimo ${
                parentQty + 1
              }).`,
              "info",
            );
          }
        });
      } catch (error) {
        this.$fun.alert(
          "Error al cargar datos del requerimiento para ampliación",
          "error",
        );
      }
    },
    openTraceability(row) {
      this.selectedTraceabilityReqID = Number(row?.ReqID || 0);
      if (!this.selectedTraceabilityReqID) {
        this.$fun.alert("No se encontró el ID del requerimiento", "warning");
        return;
      }
      this.dialogTraceability = true;
    },
    onDatesLoaded(dates, item) {
      this.currentCampaignDates = dates;
      if (dates && dates.CmpEndDate) {
        if (
          this.isReqEndContractDisabled(item) ||
          !item.ReqEndContract ||
          item.ReqID == 0
        ) {
          item.ReqEndContract = dates.CmpEndDate;
        }
      }
    },
    isReqEndContractDisabled(item) {
      if (
        !item ||
        !item.TypeMotiveRequirement ||
        !this.motiveRequirementItems ||
        !this.motiveRequirementItems.length
      ) {
        return false;
      }
      const found = this.motiveRequirementItems.find(
        (x) => String(x.DedValue) === String(item.TypeMotiveRequirement),
      );
      return found ? Number(found.DedHelper) === 1 : false;
    },
    onMotiveRequirementChanged(motiveVal, item) {
      if (this.isReqEndContractDisabled(item)) {
        if (this.currentCampaignDates && this.currentCampaignDates.CmpEndDate) {
          item.ReqEndContract = this.currentCampaignDates.CmpEndDate;
        }
      }
    },
    onAreaChanged(areID, item) {
      item.AreID = areID;
      item.ReqPstID = null;
    },
    onPositionSelected(position, item) {
      if (position && typeof position === "object") {
        item.PstObjective = position.PstObjective || "";
        item.ImmediateBoss = position.ParentPstName || "";
      } else {
        item.PstObjective = "";
        item.ImmediateBoss = "";
      }
    },
    validateProjectionQuantity(row, requirement) {
      if (Number(row.WprQuantityProject) > Number(requirement.ReqQuantity)) {
        row.WprQuantityProject = requirement.ReqQuantity;
        this.$fun.alert(
          "La cantidad proyectada no puede ser mayor a la cantidad total requerida",
          "warning",
        );
      }
    },
    updateProjectionGender(row, changedField, requirement) {
      let total = Math.max(0, parseInt(row.WprQuantityProject) || 0);
      let male = Math.max(0, parseInt(row.WprQuantityMale) || 0);
      let female = Math.max(0, parseInt(row.WprQuantityFemale) || 0);

      // Sum of other rows IN THE SAME WEEK (same PdsID)
      let maxAllowedForThisRow = Number(requirement.ReqQuantity) || 0;
      if (row.PdsID) {
        const otherRowsSum = (requirement.Projections || [])
          .filter(
            (p) =>
              p.SecStatus !== 0 &&
              p !== row &&
              String(p.PdsID) === String(row.PdsID),
          )
          .reduce((sum, p) => sum + (Number(p.WprQuantityProject) || 0), 0);

        maxAllowedForThisRow = Math.max(0, maxAllowedForThisRow - otherRowsSum);
      }

      if (changedField === "week" && row.PdsID) {
        if (!this.isAdmin && this.isPastPeriod(row.PdsID)) {
          const weekName = this.getPeriodName(row.PdsID) || "esta semana";
          this.$fun.alert(
            `No puede seleccionar semanas pasadas ni la semana actual (${weekName}) para el requerimiento masivo. Debe seleccionar una semana futura.`,
            "warning",
          );
          row.PdsID = null;
          return;
        }
      }

      if (changedField === "total" || changedField === "week") {
        if (total > maxAllowedForThisRow) {
          total = maxAllowedForThisRow;
          const weekName = this.getPeriodName(row.PdsID) || "esta semana";
          this.$fun.alert(
            `La cantidad proyectada total para la ${weekName} no puede superar el límite por semana de ${requirement.ReqQuantity}. Para esta fila, el máximo disponible es ${maxAllowedForThisRow}.`,
            "warning",
          );
        }
        row.WprQuantityProject = total;
        if (male > total) {
          row.WprQuantityMale = total;
          row.WprQuantityFemale = 0;
        } else {
          row.WprQuantityFemale = total - male;
        }
      } else if (changedField === "male") {
        if (male > total) {
          male = total;
          this.$fun.alert(
            "La cantidad de hombres no puede ser mayor al total proyectado",
            "warning",
          );
        }
        row.WprQuantityMale = male;
        row.WprQuantityFemale = total - male;
      } else if (changedField === "female") {
        if (female > total) {
          female = total;
          this.$fun.alert(
            "La cantidad de mujeres no puede ser mayor al total proyectado",
            "warning",
          );
        }
        row.WprQuantityFemale = female;
        row.WprQuantityMale = total - female;
      }
    },
    loadPeriods() {
      _sCreationPeriods
        .list(1, this.periodYear, this.$fun.getUserID())
        .then((r) => {
          this.periodsList = r.data || [];
        })
        .catch(() => {});
    },
    openAdjustProjections(row) {
      this.selectedReqQuantity = Number(row.ReqQuantity) || 0;
      this.selectedReqID = row.ReqID;
      this.dialogAdjustProjections = true;
    },
    onProjectionSaved() {
      this.$refs?.grid?.refresh?.() || this.$forceUpdate();
    },
    isPastPeriod(pdsID) {
      if (!pdsID || !this.periodsList || !this.periodsList.length) return false;
      const period = this.periodsList.find(
        (p) => String(p.PdsID) === String(pdsID),
      );
      if (!period || !period.PdsDateBegin) return false;

      const todayStr = new Date().toISOString().slice(0, 10);
      const todayWeek = this.periodsList.find(
        (p) =>
          String(p.PdsDateBegin).slice(0, 10) <= todayStr &&
          String(p.PdsDateEnd).slice(0, 10) >= todayStr,
      );

      if (todayWeek && todayWeek.PdsNum) {
        // Bloquear semanas anteriores Y la misma semana actual
        return Number(period.PdsNum) <= Number(todayWeek.PdsNum);
      }

      const endStr = period.PdsDateEnd
        ? String(period.PdsDateEnd).slice(0, 10)
        : String(period.PdsDateBegin).slice(0, 10);

      return endStr <= todayStr;
    },
    getPeriodName(pdsID) {
      if (!pdsID) return "";

      const period = this.periodsList.find(
        (p) => String(p.PdsID) === String(pdsID),
      );
      return period ? period.PdsName : `Semana ${pdsID}`;
    },
    getWeeklyTotals(item) {
      if (!item || !item.Projections) return [];

      const activeProjections = item.Projections.filter(
        (p) => p.SecStatus !== 0 && p.PdsID,
      );

      const groups = {};
      activeProjections.forEach((p) => {
        const key = p.PdsID;
        if (!groups[key]) {
          groups[key] = {
            PdsID: key,
            total: 0,
            male: 0,
            female: 0,
          };
        }
        groups[key].total += Number(p.WprQuantityProject) || 0;
        groups[key].male += Number(p.WprQuantityMale) || 0;
        groups[key].female += Number(p.WprQuantityFemale) || 0;
      });

      return Object.values(groups);
    },
    getDistributedTotal(item) {
      if (!item) return 0;
      if (this.isCampaignType(item)) {
        if (!item.Projections) return 0;
        return item.Projections.filter((p) => p.SecStatus !== 0).reduce(
          (sum, p) => sum + (Number(p.WprQuantityProject) || 0),
          0,
        );
      } else {
        if (!item.ProfessionalSchedules) return 0;
        return item.ProfessionalSchedules.filter(
          (p) => p.SecStatus !== 0,
        ).reduce((sum, p) => sum + (Number(p.PscQuantityProject) || 0), 0);
      }
    },
    getDistributionClass(item) {
      const total = this.getDistributedTotal(item);
      const req = Number(item.ReqQuantity) || 0;
      if (total === req) return "text-success-custom";

      if (total > req) return "text-danger-custom";

      return "text-warning-custom";
    },
    isRequirementApproved(item) {
      if (!item) return false;
      if (item.ReqID && [5, 6].includes(Number(item.ReqStatus))) {
        return true;
      }
      if (
        item.ReqID &&
        item.UsrCreateID &&
        String(item.UsrCreateID) !== String(this.$fun.getUserID())
      ) {
        return true;
      }
      return false;
    },
    addProfessionalProjection(item) {
      if (!item.ProfessionalSchedules)
        this.$set(item, "ProfessionalSchedules", []);
      const newProj = {
        PscID: 0,
        ReqID: item.ReqID || 0,
        PscEstimatedDate: null,
        PscQuantityProject: 1,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      item.ProfessionalSchedules.push(newProj);
    },
    removeProfessionalSchedule(item, schedule) {
      if (!item.ProfessionalSchedules) return;

      if (schedule.PscID) {
        schedule.SecStatus = 0;
        schedule.UsrUpdateID = this.$fun.getUserID();
      } else {
        const index = item.ProfessionalSchedules.indexOf(schedule);
        if (index > -1) item.ProfessionalSchedules.splice(index, 1);
      }
    },
    validateProfessionalRowQty(row, item) {
      let qty = parseInt(row.PscQuantityProject) || 0;
      if (qty < 1) qty = 1;
      row.PscQuantityProject = qty;
    },
    isCampaignType(item) {
      const campaignType = this.$const.TypeStaffRequirement["Campana"] || 2;
      return Number(item.TypeRequirement) === Number(campaignType);
    },
    addProjection(item) {
      if (!item.Projections) this.$set(item, "Projections", []);

      const newProjection = {
        PdsID: null,
        WprQuantityProject: 1,
        TypeTurn: null,
        WprQuantityMale: 1,
        WprQuantityFemale: 0,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      if (item.ReqID) newProjection.ReqID = item.ReqID;

      item.Projections.push(newProjection);
    },
    removeProjection(item, projection) {
      if (!item.Projections) return;

      if (
        !this.isAdmin &&
        projection.PdsID &&
        this.isPastPeriod(projection.PdsID)
      ) {
        this.$fun.alert(
          "No se puede eliminar una semana pasada de proyección",
          "warning",
        );
        return;
      }

      if (projection.WprID) {
        projection.SecStatus = 0;
        projection.UsrUpdateID = this.$fun.getUserID();
      } else {
        const index = item.Projections.indexOf(projection);
        if (index > -1) item.Projections.splice(index, 1);
      }
    },
    async save(item) {
      if (item.ReqID && [5, 6].includes(Number(item.ReqStatus))) {
        if (!this.canEditBudget) {
          this.$fun.alert(
            "El requerimiento ya está aprobado/cerrado y no puede editarse",
            "warning",
          );
          return;
        }
      }

      if (
        item.ReqID &&
        item.UsrCreateID &&
        String(item.UsrCreateID) !== String(this.$fun.getUserID())
      ) {
        if (!this.canEditBudget && !this.isAdmin) {
          this.$fun.alert(
            "No tiene permisos para modificar este requerimiento porque fue creado por otro usuario",
            "warning",
          );
          return;
        }
      }

      if (!item.CmpID) {
        this.$fun.focusFieldError(
          this,
          "selectCampaign",
          "Seleccione una campaña",
        );
        this.$fun.alert("Seleccione una campaña", "warning");
        return;
      }
      if (!this.userAreID && !item.AreID) {
        this.$fun.focusFieldError(this, "selectArea", "Seleccione un área");
        this.$fun.alert("Seleccione un área", "warning");
        return;
      }
      if (!item.ReqPstID) {
        this.$fun.focusFieldError(
          this,
          "selectPosition",
          "Seleccione un cargo",
        );
        this.$fun.alert("Seleccione un cargo", "warning");
        return;
      }
      if (!item.TypeRequirement) {
        this.$fun.focusFieldError(
          this,
          "typeRequirement",
          "Seleccione un tipo de requerimiento",
        );
        this.$fun.alert("Seleccione el tipo de requerimiento", "warning");
        return;
      }
      if (!item.CceID) {
        this.$fun.focusFieldError(
          this,
          "costCenterArea",
          "Seleccione un centro de costo",
        );
        this.$fun.alert("Seleccione un centro de costo", "warning");
        return;
      }
      if (!item.ReqQuantity || Number(item.ReqQuantity) <= 0) {
        this.$fun.focusFieldError(
          this,
          "reqQuantity",
          "La cantidad debe ser mayor a 0",
        );
        this.$fun.alert("La cantidad debe ser mayor a 0", "warning");
        return;
      }
      if (item.ParentReqID && item.ParentReqQuantity) {
        if (Number(item.ReqQuantity) <= Number(item.ParentReqQuantity)) {
          this.$fun.focusFieldError(
            this,
            "reqQuantity",
            "Cantidad insuficiente",
          );
          this.$fun.alert(
            `Para una ampliación, la nueva cantidad total de vacantes (${item.ReqQuantity}) debe ser estrictamente mayor a las vacantes del requerimiento anterior (${item.ParentReqQuantity}).`,
            "warning",
          );
          return;
        }
      }
      if (this.isValidateBudget && !item.TypePayroll) {
        this.$fun.alert("Seleccione el tipo de planilla", "warning");
        return;
      }
      // Si el validador de presupuesto, debe llenar el tipo de compensación y Valor 1
      if (this.isValidateBudget) {
        if (!item.ReqPaymentType) {
          this.$fun.alert("Seleccione el tipo de compensación", "warning");
          return;
        }
        const val1 = this.getPayDisplayValue(item.ReqPayValue1);
        if (!val1 || Number(val1) <= 0) {
          this.$fun.focusFieldError(
            this,
            "reqPayValue1",
            "Ingrese un valor válido",
          );
          this.$fun.alert(
            "Ingrese el valor del tipo de compensación",
            "warning",
          );
          return;
        }
        if ([2, 3].includes(Number(item.ReqPaymentType))) {
          const val2 = this.getPayDisplayValue(item.ReqPayValue2);
          if (!val2 || Number(val2) <= 0) {
            this.$fun.focusFieldError(
              this,
              "reqPayValue2",
              "Ingrese un valor válido",
            );
            this.$fun.alert(
              "Ingrese el segundo valor de compensación",
              "warning",
            );
            return;
          }
          if (
            Number(item.ReqPaymentType) === 2 &&
            Number(val2) < Number(val1)
          ) {
            this.$fun.alert(
              "El valor máximo no puede ser menor al mínimo",
              "warning",
            );
            return;
          }
        }
        if (Number(item.ReqPaymentType) === 3) {
          const val3 = this.getPayDisplayValue(item.ReqPayValue3);
          if (!val3 || Number(val3) <= 0) {
            this.$fun.focusFieldError(
              this,
              "reqPayValue3",
              "Ingrese el Tipo C",
            );
            this.$fun.alert("Ingrese el valor del Tipo C", "warning");
            return;
          }
        }
      }

      if (this.isCampaignType(item)) {
        const projections = (item.Projections || []).filter(
          (p) => p.SecStatus !== 0,
        );
        if (projections.length === 0) {
          this.$fun.alert(
            "Registre al menos una proyección semanal",
            "warning",
          );
          return;
        }
        const invalid = projections.find(
          (row) => !row.PdsID || Number(row.WprQuantityProject) <= 0,
        );
        if (invalid) {
          this.$fun.alert(
            "Complete semana y cantidad en todas las proyecciones",
            "warning",
          );
          return;
        }

        if (!this.isAdmin) {
          const pastProjection = projections.find(
            (row) => row.PdsID && this.isPastPeriod(row.PdsID),
          );
          if (pastProjection) {
            const weekName = this.getPeriodName(pastProjection.PdsID);
            this.$fun.alert(
              `No se pueden registrar ni incluir semanas anteriores (${weekName}) para el requerimiento masivo`,
              "warning",
            );
            return;
          }
        }

        // Validar que no haya duplicados de turno para la misma semana
        const weekTurnsMap = {};
        for (const p of projections) {
          if (p.PdsID) {
            const key = `${p.PdsID}-${p.TypeTurn}`;
            if (weekTurnsMap[key]) {
              const weekName = this.getPeriodName(p.PdsID);
              this.$fun.alert(
                `Error: No puede registrar duplicados del mismo turno para la semana ${weekName}.`,
                "warning",
              );
              return;
            }
            weekTurnsMap[key] = true;
          }
        }

        // Sum total of all active projections per week cannot exceed ReqQuantity
        const weeks = {};
        projections.forEach((p) => {
          if (p.PdsID) {
            const key = p.PdsID;
            weeks[key] =
              (weeks[key] || 0) + (Number(p.WprQuantityProject) || 0);
          }
        });

        for (const pdsID in weeks) {
          if (weeks[pdsID] > Number(item.ReqQuantity)) {
            const weekName = this.getPeriodName(pdsID);
            this.$fun.alert(
              `La cantidad total proyectada para la ${weekName} (${weeks[pdsID]}) no puede superar el límite por semana de ${item.ReqQuantity}`,
              "warning",
            );
            return;
          }
        }
      } else {
        // Reclutamiento Profesional: Validar cronograma de fechas estimadas
        const schedules = (item.ProfessionalSchedules || []).filter(
          (p) => p.SecStatus !== 0,
        );
        if (schedules.length === 0) {
          this.$fun.alert(
            "Debe registrar al menos una fecha estimada en el cronograma de ingreso",
            "warning",
          );
          return;
        }

        const invalid = schedules.find(
          (row) => !row.PscEstimatedDate || Number(row.PscQuantityProject) <= 0,
        );
        if (invalid) {
          this.$fun.alert(
            "Complete la fecha estimada y la cantidad en todas las filas del cronograma",
            "warning",
          );
          return;
        }

        if (!this.isAdmin) {
          const todayStr = this.minAllowedDate;
          const pastSchedule = schedules.find(
            (row) =>
              row.PscEstimatedDate &&
              String(row.PscEstimatedDate).slice(0, 10) < todayStr,
          );
          if (pastSchedule) {
            this.$fun.alert(
              "No se pueden registrar fechas estimadas de ingreso anteriores a la fecha actual",
              "warning",
            );
            return;
          }
        }

        const totalEstimated = schedules.reduce(
          (sum, p) => sum + (Number(p.PscQuantityProject) || 0),
          0,
        );
        if (totalEstimated !== Number(item.ReqQuantity)) {
          this.$fun.alert(
            `La suma de las cantidades estimadas (${totalEstimated}) debe ser igual a la cantidad total de vacantes del requerimiento (${item.ReqQuantity})`,
            "warning",
          );
          return;
        }
      }

      // Validar fecha de fin de contrato para no administradores
      if (!this.isAdmin && item.ReqEndContract) {
        const todayStr = this.minAllowedDate;
        if (String(item.ReqEndContract).slice(0, 10) < todayStr) {
          this.$fun.alert(
            "La fecha fin de contrato no puede ser anterior a la fecha actual",
            "warning",
          );
          return;
        }
      }

      // Validar que las fechas de entrada sean menores a la fecha de fin de contrato
      if (item.ReqEndContract) {
        const reqEndDateStr = String(item.ReqEndContract).slice(0, 10);
        if (this.isCampaignType(item)) {
          const projections = (item.Projections || []).filter(
            (p) => p.SecStatus !== 0,
          );
          const invalidDate = projections.find((p) => {
            if (!p.PdsDateBegin) return false;
            return String(p.PdsDateBegin).slice(0, 10) >= reqEndDateStr;
          });
          if (invalidDate) {
            this.$fun.alert(
              "Las fechas de las semanas proyectadas deben ser menores a la fecha fin de contrato",
              "warning",
            );
            return;
          }
        } else {
          const schedules = (item.ProfessionalSchedules || []).filter(
            (p) => p.SecStatus !== 0,
          );
          const invalidDate = schedules.find((p) => {
            if (!p.PscEstimatedDate) return false;
            return String(p.PscEstimatedDate).slice(0, 10) >= reqEndDateStr;
          });
          if (invalidDate) {
            this.$fun.alert(
              "Las fechas de entrada estimadas deben ser menores a la fecha fin de contrato",
              "warning",
            );
            return;
          }
        }
      }

      if (!item.ReqStatus) item.ReqStatus = this.$const.SreStatus.EnCreacion;

      if (!item.SecStatus) item.SecStatus = this.$const.SecStatus.Activo;

      if (item.ReqID) {
        try {
          const previousResponse = await _sHmnStaffingRequirement.byID(
            item.ReqID,
            this.$fun.getUserID(),
          );
          const previousSnapshot = this.toAuditRequirementSnapshot(
            previousResponse?.data || {},
          );
          const currentSnapshot = this.toAuditRequirementSnapshot(item);
          const changes = this.buildRequirementChangeSet(
            previousSnapshot,
            currentSnapshot,
          );

          if (changes.length) {
            this.auditRequirementAction(
              "EDIT",
              item,
              {
                source: "staffing-requirement-form",
                actionOrigin: "save",
              },
              changes,
            );
          }
        } catch (_) {
          // Si falla el diff remoto, no se bloquea el guardado.
        }
      }

      // Encriptar valores de pago
      if (this.canEditBudget) {
        this.encryptPayValues(item);
      }

      if (!item.TypeSeeking) item.TypeSeeking = 1;

      item.AreID = this.userAreID || item.AreID;
      item.UsrCreateID = this.$fun.getUserID();
      item.UsrUpdateID = this.$fun.getUserID();
      item.save();
    },
    openCircuitConfig(row) {
      this.selectedReqID = row.ReqID;
      this.selectedReqPstID = row.ReqPstID || 0;
      this.selectedReqStatus = 1;
      this.bulkCircuitRequirements = [];
      this.dialogCircuit = true;
    },
    openCircuitView(row) {
      this.selectedReqID = row.ReqID;
      this.selectedReqPstID = row.ReqPstID || 0;
      this.selectedReqStatus = row.ReqStatus;
      this.bulkCircuitRequirements = [];
      this.dialogCircuit = true;
    },
    openBulkCircuitConfig() {
      if (!this.selectedRequirements.length) return;
      const firstReq = this.selectedRequirements[0];
      this.selectedReqID = firstReq.ReqID;
      this.selectedReqPstID = firstReq.ReqPstID || 0;
      this.selectedReqStatus = 1;
      this.bulkCircuitRequirements = [...this.selectedRequirements];
      this.dialogCircuit = true;
    },
    isFullyApproved(row) {
      return row.ReqStatus == 5;
    },
    openAdjustProjections(row) {
      this.selectedReqQuantity = Number(row.ReqQuantity) || 0;
      this.selectedReqID = Number(row.ReqID) || 0;
      this.dialogAdjustProjections = true;
    },
    onProjectionSaved() {
      this.$refs?.grid?.refresh?.() || this.$forceUpdate();
    },
    onCircuitSaved() {
      this.selectedRequirements = [];
      this.bulkCircuitRequirements = [];
      this.$refs?.grid?.refresh?.() || this.$forceUpdate();
    },
    // ---- Métodos de Aprobación y Envío Masivo ----
    isRowSelectable(row) {
      if (!row || !row.ReqID) return false;

      // 1. Caso Borrador (ReqStatus = 1): Envío masivo al circuito
      if (Number(row.ReqStatus) === 1) {
        // No permitir seleccionar borradores si ya hay una selección activa de firmas
        if (this.selectionMode === "approval") return false;
        // Solo el creador del requerimiento puede enviarlo a circuito
        return Number(row.UsrCreateID) === Number(this.$fun.getUserID());
      }

      // 2. Caso Pendiente de Firma (ReqStatus 2, 3, 4): Aprobación / Rechazo Masivo
      if ([2, 3, 4].includes(Number(row.ReqStatus))) {
        // El usuario validador de presupuesto (Budget) no puede firmar en lote
        if (this.isValidateBudget) return false;
        // No permitir seleccionar firmas si ya hay una selección activa de borradores
        if (this.selectionMode === "draft") return false;
        if (!row.CurrentPendingRapID) return false;

        const isPendingMyTurn =
          Number(row.CurrentPendingApprovalPstID) === Number(this.userPstID);
        return isPendingMyTurn;
      }

      return false;
    },
    isRowSelected(row) {
      if (!row || !row.ReqID) return false;
      return this.selectedRequirements.some((r) => r.ReqID === row.ReqID);
    },
    toggleRowSelection(row) {
      if (!this.isRowSelectable(row)) return;
      const index = this.selectedRequirements.findIndex(
        (r) => r.ReqID === row.ReqID,
      );
      if (index > -1) {
        this.selectedRequirements.splice(index, 1);
      } else {
        this.selectedRequirements.push(row);
      }
    },
    toggleSelectAllEligible() {
      if (this.isAllEligibleSelected) {
        this.selectedRequirements = [];
      } else {
        this.eligibleRows.forEach((row) => {
          if (!this.isRowSelected(row)) {
            this.selectedRequirements.push(row);
          }
        });
      }
    },
    clearSelection() {
      this.selectedRequirements = [];
    },
    async deleteRequirement(row) {
      if (!row || !row.ReqID) return;

      if (Number(row.ReqStatus) !== 1) {
        this.$fun.alert("Solo se pueden eliminar requerimientos en estado Borrador", "warning");
        return;
      }

      const confirmed = await this.$fun.confirm(
        `¿Está seguro de eliminar el requerimiento #${row.ReqID} (${row.PstName || "Cargo"})?`,
        "Esta acción no se puede deshacer.",
        "warning"
      );

      if (!confirmed) return;

      try {
        const response = await _sHmnStaffingRequirement.delete(row.ReqID, this.$fun.getUserID());
        if (response?.status === 200 || response?.data) {
          this.$fun.alert("Requerimiento eliminado correctamente", "success");
          this.auditRequirementAction("DELETE", row, {
            source: "staffing-requirement-grid",
            actionOrigin: "deleteRequirement",
          });
          if (this.$refs.grid) {
            this.$refs.grid.searchBtn();
          }
        }
      } catch (error) {
        this.$fun.alert(
          error?.response?.data?.Message ||
            error?.response?.data ||
            "Error al eliminar el requerimiento",
          "error"
        );
      }
    },
    getSelectableTooltip(row) {
      if (!row) return "No seleccionable";

      // Tooltips para Borradores (ReqStatus = 1)
      if (Number(row.ReqStatus) === 1) {
        if (this.selectionMode === "approval") {
          return "No puede mezclar borradores con requerimientos pendientes de firma.";
        }
        if (Number(row.UsrCreateID) !== Number(this.$fun.getUserID())) {
          return "Solo el usuario que creó este requerimiento puede enviarlo a aprobación.";
        }
        return "Seleccionar borrador para enviar a circuito de aprobación";
      }

      // Tooltips para Requerimientos en Circuito
      if (this.selectionMode === "draft") {
        return "No puede mezclar requerimientos en circuito con borradores.";
      }
      if (this.isValidateBudget) {
        return "El usuario de presupuesto debe configurar los sueldos y planilla individualmente en el circuito.";
      }
      if (row.ReqStatus === 5 || row.ReqStatus === 6) {
        return "Requerimiento ya aprobado/finalizado.";
      }
      if (row.ReqStatus === 7) {
        return "Requerimiento anulado/rechazado.";
      }
      if (!row.CurrentPendingRapID) {
        return "No tiene un nivel pendiente de firma.";
      }
      if (Number(row.CurrentPendingApprovalPstID) !== Number(this.userPstID)) {
        return "Aún no es su turno de firma o no corresponde a su cargo aprobador.";
      }
      return "Seleccionar para aprobación o rechazo masivo";
    },
    async executeBulkSend() {
      const reqIds = this.selectedRequirements.map((r) => r.ReqID);
      if (!reqIds.length) return;

      const confirm = await this.$fun.alert(
        `¿Desea enviar ${reqIds.length} requerimiento(s) en borrador al circuito de aprobación?`,
        "question",
      );
      if (!confirm?.isConfirmed) return;

      this.processingBulkSend = true;
      try {
        await _sApproval.sendBatch(reqIds, this.$fun.getUserID());
        this.$fun.alert(
          `${reqIds.length} requerimiento(s) enviados al circuito de aprobación exitosamente.`,
          "success",
        );
        this.selectedRequirements = [];
        this.$refs?.grid?.refresh?.();
      } catch (error) {
        const msg =
          error?.response?.data?.Message ||
          error?.response?.data ||
          "Error al enviar requerimientos a aprobación";
        this.$fun.alert(msg, "error");
      } finally {
        this.processingBulkSend = false;
      }
    },
    openBulkApproval(actionType) {
      if (this.selectedRequirements.length === 0) {
        this.$fun.alert("Seleccione al menos un requerimiento", "warning");
        return;
      }
      this.bulkActionType = actionType;
      this.bulkObservation = "";
      this.dialogBulkApproval = true;
    },
    async executeBulkApproval() {
      if (
        this.bulkActionType === "reject" &&
        (!this.bulkObservation || !this.bulkObservation.trim())
      ) {
        this.$fun.alert(
          "Debe ingresar un motivo para el rechazo masivo",
          "warning",
        );
        return;
      }

      const rapIds = this.selectedRequirements
        .map((r) => r.CurrentPendingRapID)
        .filter((id) => !!id);

      if (rapIds.length === 0) {
        this.$fun.alert(
          "No se encontraron firmas válidas para procesar",
          "warning",
        );
        return;
      }

      this.processingBulk = true;
      try {
        const payload = {
          RapIDs: rapIds,
          RapStatus: this.bulkActionType === "approve" ? 4 : 3,
          RapObservation: this.bulkObservation || null,
        };

        await _sApproval.approveBatch(payload, this.$fun.getUserID());

        const actionText =
          this.bulkActionType === "approve" ? "aprobados" : "rechazados";
        this.$fun.alert(
          `${rapIds.length} requerimiento(s) ${actionText} exitosamente.`,
          "success",
        );

        this.selectedRequirements = [];
        this.dialogBulkApproval = false;
        this.bulkObservation = "";
        this.$refs?.grid?.refresh?.();
      } catch (error) {
        const msg =
          error?.response?.data?.Message ||
          error?.response?.data ||
          "Ocurrió un error al procesar la acción masiva";
        this.$fun.alert(msg, "error");
      } finally {
        this.processingBulk = false;
      }
    },
  },
  created() {
    this.auditLogger = createModuleAuditLogger({
      service: _sAuditService,
      getUserID: () => this.$fun.getUserID(),
      moduleName: "HumanResource.RecruitmentSelection",
      entityName: "HmnStaffingRequirement",
      getContext: () => ({
        route: this.$route?.path || null,
      }),
    });

    this.filter.UsrCreateID = this.$fun.getUserID();
    const userInfo = this.$fun.getUserInfo();
    if (!this.$fun.isAdmin()) {
      this.userAreID = userInfo?.CtrContract?.AreID || 0;
    }
  },
};
</script>

<style scoped="scoped">
:root {
  --c-bg: #f8f9fb;
  --c-surface: #ffffff;
  --c-border: #e4e7ed;
  --c-border-focus: #94a3b8;
  --c-text: #1e293b;
  --c-text-secondary: #64748b;
  --c-text-muted: #94a3b8;
  --c-accent: #3b5bdb;
  --c-accent-soft: #eef2ff;
  --c-success: #0d9488;
  --c-warning: #d97706;
  --c-danger: #e11d48;
  --radius: 8px;
  --radius-sm: 5px;
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --font: "DM Sans", "Segoe UI", sans-serif;
}

/* ── Base ──────────────────────────────────────────────────── */
.staffing-wrapper {
  font-family: var(--font);
  background: var(--c-bg);
  min-height: 100%;
}

.staffing-container {
  max-width: 100%;
}

/* ── Admin alert ───────────────────────────────────────────── */
.admin-alert {
  display: flex;
  align-items: center;
  margin: 12px 16px;
  padding: 10px 16px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: var(--radius);
  font-size: 13px;
  color: #92400e;
  font-weight: 500;
}

/* ── Filter bar ────────────────────────────────────────────── */
.filter-bar {
  display: flex;
  gap: 12px;
  padding: 16px 12px 8px;
  flex-wrap: wrap;
}

.filter-group {
  flex: 1;
  min-width: 160px;
}

.filter-input {
  font-size: 13px !important;
}

/* ── Form panel ────────────────────────────────────────────── */
.form-panel {
  padding: 4px 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.2s;
}

.form-section:hover {
  box-shadow: var(--shadow-md);
}

.form-section-label {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--c-text-muted);
  margin-bottom: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.form-field {
  min-width: 0;
}

.form-field--full {
  grid-column: 1 / -1;
}

/* ── Projection section ────────────────────────────────────── */
.projection-section {
  padding: 20px;
}

.projection-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.projection-hint {
  display: block;
  font-size: 12px;
  color: var(--c-text-muted);
  margin-top: 2px;
  font-weight: 400;
}

.btn-add-projection {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 14px;
  background-color: #3b5bdb;
  color: #fff;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
}

.btn-add-projection:hover {
  background: #2f4abf;
  transform: translateY(-1px);
}

.btn-add-projection:active {
  transform: translateY(0);
}

.projection-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 28px;
  border: 1.5px dashed var(--c-border);
  border-radius: var(--radius);
  background: #fafafa;
  color: var(--c-text-muted);
  font-size: 13px;
  text-align: center;
}

.projection-list-header {
  display: grid;
  grid-template-columns: 1fr 160px 90px 90px 90px 40px;
  gap: 8px;
  padding: 0 4px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c-text-muted);
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--c-border);
  margin-bottom: 4px;
}

.projection-row {
  display: grid;
  grid-template-columns: 1fr 160px 90px 90px 90px 40px;
  gap: 8px;
  align-items: center;
  padding: 6px 4px;
  border-radius: var(--radius-sm);
  transition: background 0.15s;
}

.projection-row:hover {
  background: #f8fafc;
}

.projection-cell {
  min-width: 0;
}

.projection-cell--action {
  display: flex;
  justify-content: center;
}

.qty-field {
  font-size: 13px !important;
}

/* Override Vuetify outlined for qty field */
.qty-field:deep(.v-input__slot) {
  border-color: var(--c-border) !important;
  border-radius: var(--radius-sm) !important;
}

.btn-remove-projection {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid var(--c-border);
  border-radius: 50%;
  color: var(--c-text-muted);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.btn-remove-projection:hover {
  background: #fff1f2;
  border-color: #fda4af;
  color: var(--c-danger);
}

/* ── Row actions ───────────────────────────────────────────── */
.row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.action-btn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.action-btn:active {
  transform: translateY(0);
}

.action-btn--print {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #86efac;
  padding: 5px 8px;
}

.action-btn--send {
  background: #3b5bdb;
  color: #fff;
}

.action-btn--view {
  background: #f0fdf4;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

/* ── Transitions ───────────────────────────────────────────── */
.fade-expand-enter-active,
.fade-expand-leave-active {
  transition: opacity 0.25s ease, max-height 0.3s ease;
  overflow: hidden;
  max-height: 600px;
}

.fade-expand-enter,
.fade-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.row-fade-enter-active,
.row-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.row-fade-enter,
.row-fade-leave-to {
  opacity: 0;
  transform: translateX(-8px);
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.payment-type-hint {
  font-size: 12px;
  color: var(--c-text-muted);
  margin-bottom: 4px;
}

.projection-summary-card {
  margin-top: 16px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: var(--radius);
  padding: 14px;
}

.summary-card-title {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.summary-badge {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  min-width: 140px;
}

.summary-week {
  font-size: 11px;
  font-weight: 700;
  color: #3b5bdb;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 4px;
}

.summary-details {
  display: flex;
  flex-direction: column;
}

.summary-qty-total {
  font-size: 13px;
  color: #1e293b;
}

.summary-qty-split {
  font-size: 11px;
  color: #64748b;
  display: flex;
  align-items: center;
  margin-top: 2px;
}

.text-success-custom {
  color: var(--c-success) !important;
}

.text-danger-custom {
  color: var(--c-danger) !important;
  font-weight: bold;
}

.text-warning-custom {
  color: var(--c-warning) !important;
}

.hierarchy-box {
  border: 2px solid #000;
  padding: 10px;
  text-align: center;
  margin: 10px auto;
  width: 220px;
}

.hierarchy-container {
  border: 2px solid #000;
  padding: 15px;
}

@media print {
  .hierarchy-box {
    border: 2px solid #000 !important;
  }

  .hierarchy-container {
    border: 2px solid #000 !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

.action-btn--adjust {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
}

.action-btn--delete {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  padding: 4px 6px;
  border-radius: 4px;
}
.action-btn--delete:hover {
  background: #fee2e2;
  color: #991b1b;
}

.qty-field input {
  text-align: center;
}
.prof-projection-list-header {
  display: grid;
  grid-template-columns: 1fr 180px 40px;
  gap: 12px;
  padding: 0 4px 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c-text-muted);
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--c-border);
  margin-bottom: 4px;
}

.prof-projection-row {
  display: grid;
  grid-template-columns: 1fr 180px 40px;
  gap: 12px;
  align-items: center;
  padding: 6px 4px;
  border-radius: var(--radius-sm);
  transition: background 0.15s;
}

.prof-projection-row:hover {
  background: #f8fafc;
}

/* ── Extension Banner ──────────────────────────────────────── */
.extension-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-left: 4px solid #0284c7;
  border-radius: var(--radius);
  margin-bottom: 8px;
}

.extension-banner-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.extension-banner-body {
  flex: 1;
}

.extension-banner-title {
  font-size: 13px;
  font-weight: 700;
  color: #0369a1;
}

.extension-banner-text {
  font-size: 12px;
  color: #0c4a6e;
  margin-top: 2px;
}

.action-btn--expand {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

.action-btn--expand:hover {
  background: #dbeafe;
}

.action-btn--trace {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.action-btn--trace:hover {
  background: #f1f5f9;
  color: #1e293b;
}

/* ── Bulk Actions Floating Bar ────────────────────────────── */
.bulk-floating-bar {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: rgba(30, 41, 59, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  padding: 8px 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3),
    0 10px 10px -5px rgba(0, 0, 0, 0.2);
}

.bulk-floating-content {
  display: flex;
  align-items: center;
  gap: 14px;
}

.bulk-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3b82f6;
  color: #ffffff;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
}

.bulk-label {
  color: #f8fafc;
  font-size: 13px;
  white-space: nowrap;
}

.bulk-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bulk-btn {
  text-transform: none;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.3px;
  border-radius: 20px;
  padding: 0 14px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.bulk-btn-clear {
  min-width: 32px !important;
  width: 32px;
  height: 32px !important;
  padding: 0 !important;
  border-radius: 50%;
  color: #94a3b8 !important;
}

.bulk-btn-clear:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f8fafc !important;
}

.select-all-btn {
  text-transform: none;
  font-weight: 600;
  font-size: 11px;
  border-radius: 6px;
}

.cursor-pointer {
  cursor: pointer;
}

/* ── Animaciones ───────────────────────────────────────────── */
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.7, 0, 0.84, 0);
}
.slide-fade-enter {
  transform: translate(-50%, 40px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translate(-50%, 40px);
  opacity: 0;
}
</style>
